import { Controller } from "@hotwired/stimulus"

// Shows only the permission flags of the selected role. The markup ships every
// group hidden; connect() reveals the current role's. Changing the role clears
// the flags (a role change resets permissions) and disables the hidden groups'
// inputs so they are not submitted.
export default class extends Controller {
  static targets = ["role", "group"]

  connect() {
    this.reveal()
  }

  change() {
    this.element.querySelectorAll("input[type=checkbox]").forEach((box) => { box.checked = false })
    this.reveal()
  }

  reveal() {
    this.groupTargets.forEach((group) => {
      const active = group.dataset.role === this.roleTarget.value
      group.hidden = !active
      group.querySelectorAll("input").forEach((input) => { input.disabled = !active })
    })
  }
}
